import { UserInfo } from "../_models/userInfo"
import { EnterpriseInfo } from "../_models/enterpriseInfo"
import { InstituteInfo } from "../_models/instituteInfo"
import { JobOffer } from "../_models/jobOffer"
import { Activities } from "../_models/activities"
import { UserResetPassInfo } from "../_models/userResetPasswordInfo"
import axios from 'axios'
import { bus } from '../main'
import { UserSignUpInfo } from "../_models/userSignUpInfo";
import { StudentInfo } from "../_models/studentInfo";
import { DocAutorizzazioneInfo } from "../_models/docAutorizzazioneInfo";
import { RichiestaAlternanza } from '@/_models/richiestaAlternanza'
import { RichiestaTirEstivi } from '@/_models/richiestaTirEstivi'
import { RichiestaTirFormativi } from '@/_models/richiestaTirFormativi'
import { ReportVisiteInfo } from '@/_models/reportVisiteInfo'
import { DocAttestatoFinale } from '@/_models/docAttestatoFinale'
import { AttivitaIstituto } from '@/_models/attivitaIstituto'
import { PropostaLavoroInfo } from '@/_models/propostaLavoroInfo'
import { ContattoAziendaInfo } from "@/_models/contattoAzienda"
import { NotaAzienda } from "@/_models/notaAzienda"

export const userService = {
    editUserInfo,
    editEnterpriseInfo,
    editInstituteInfo,
    createJobOffer,
    sendResetLink,
    resetPassword,
    createUser,
    editStudentInfo,
    submitAuthorizationDoc,
    submitResponsabileDatiDoc,
    confirmResponsabileDatiDoc,
    refuseResponsabileDatiDoc,
    updateResponsabileDatiDoc,
    confirmAutorizzazioneStudentiDoc,
    refuseAutorizzazioneStudentiDoc,
    updateAutorizzazioneStudentiDoc,
    submitRichiestaAlternanza,
    subscribeToActivities,
    subscribeToAlternanza,
    refuseDoc,
    confirmDoc,
    deleteRichiestaAlternanza,
    updateRichiestaAlternanza,
    addUserRole,
    deleteUserRole,
    deleteAssegnazioneIndirizzoStudio,
    deleteAssegnazioneArticolazione,
    updateUserRole,
    confirmAssegnazioneArticolazione,
    confirmAssegnazioneIndirizzoStudio,
    assignTutorToAllievo,
    changeStudentActivityStatus,
    assignAllievoToAzienda,
    subscribeToColloqui,
    registerSchedule,
    sendQuestionarioCV,
    sendLinkColloquioCV,
    subscribeToTirEstivi,
    submitRichiestaTirEstivo,
    deleteRichiestaTirEstivo,
    updateRichiestaTirEstivo,
    assignAllievoToAziendaTirEstivo,
    updatePreAssegnamentoTirEstivo,
    assignTutorFormToRichiestaTirEstivo,
    confirmAbbinamento,
    generaDocumenti,
    signConvenzione,
    signProgettoOrientamento,
    confirmConvenzione,
    refuseConvenzione,
    confirmProgettoOrientamento,
    refuseProgettoOrientamento,
    subscribeToTirFormativi,
    submitRichiestaTirFormativo,
    assignAllievoToAziendaTirFormativo,
    assignTutorFormToRichiestaTirFormativo,
    saveAssegnazioneAllievoAzienda,
    refusePreAbbinamento,
    createReportVisita,
    sendConfirmReport,
    refuseReportVisita,
    signReportVisita,
    signConsenso,
    confirmConsenso,
    refuseConsenso,
    sendEmailAssegnazioneAllievoAzienda,
    sendEmailAbbinamentoCompletato,
    sendEmailConfermaAllievoAlternanza,
    sendEmailDocGenerati,
    updatePreAssegnamentoTirFormativo,
    createAttestatoFinale,
    createQuestionario,
    saveResponse,
    changeStatusPeriodoIscrizioneAttivita,
    editAttivitaIstituto,
    createAttivitaIstituto,
    assignTutorFormToRichiestaAlternanza,
    updatePreAssegnamentoAlternanza,
    signPercorsoFormativo,
    confirmPercorsoFormativo,
    refusePercorsoFormativo,
    refuseAssignment,
    updatePreAssegnamentoTirReIns,
    deletePreferenzaWorkshop,
    updatePreferenzaWorkshop,
    createPreferenzaWorkshop,
    createPropostaLavoro,
    editPropostaLavoro,
    creaCandidaturaLavoro,
    sendCandidaturaLavoro,
    changeStatusCandidatura,
    changeStatusPresenzaWorkshop,
    addGiornoWorkshop,
    deleteGiornoWorkshop,
    editGiornoWorkshop,
    addTurnoWorkshop,
    editTurnoWorkshop,
    deleteTurnoWorkshop,
    saveScheduleWorkshop,
    deleteScheduleWorkshop,
    uploadCV,
    deleteCandidatura,
    deleteProposta,
    createAllievo,
    concludiAttivita,
    createContattoAzienda,
    editContattoAzienda,
    deleteContattoAzienda,
    createNotaAzienda,
    editNotaAzienda,
    deleteNotaAzienda,
    deletePreferenzaColloquio,
    createPreferenzaColloquio,
    saveAssegnazioneAreaAzienda,
    saveAssegnazioneAreaAllievo,
    deleteAssegnazioneAreaAllievo,
    deleteAssegnazioneAreaAzienda,
    deleteAssociazioneAllievoAzienda,
    verificaUtente,
    changeStatusPresenzaColloquio,
    changeStatusPubblicazioneAttivita,
    deleteColloquioCV,
    changeTurnoColloquioCV,
    createGiornoFoglioFirme,
    deleteGiornoFoglioFirme,
    changeCorsoSicurezzaStatus,
    acceptRichiestaAlternaza,
    refuseRichiestaAlternaza,
    createIspezione,
    signIspezione,
    refuseIspezione,
    uploadDocumento,
    confermaConvenzioneAlternanza,
    refuseConvenzioneAlternanza,
    confermaPercorsoFormativo,
    rifiutaPercorsoFormativo,
    sendEmailFirmaDocAlternanza,
    editTirFormativo,
    deleteAbbinamentoAlternanza,
    uploadDocDVR,
    confirmDocDVR,
    refuseDocDVR,
    confirmOrariAllievo,
    refuseOrariAllievo,
    rateAlternanza,
    createApprendistato,
    updateApprendistato,
    deleteApprendistato,
    updateStatoPercorsoFormativo,
    deleteIscrizioneAttivitaAllievo
}

// const headUrl = "http://localhost:8181/RestApi/valtis/valtis"
// const siteUrl = "http://localhost:8080"

const headUrl = "https://valtis.infosys.it/RestApi/valtis/valtis"
const siteUrl = "https://valtis.infosys.it"

function editStudentInfo(studentInfo: StudentInfo) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/EditUserInfo", {
        params: {
            userInfo: studentInfo
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function editUserInfo(userInfo: UserInfo) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/EditUserInfo", {
        params: {
            userInfo: userInfo
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function editEnterpriseInfo(enterpriseInfo: EnterpriseInfo) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/EditEnterpriseInfo", {
        params: {
            enterpriseInfo: enterpriseInfo
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function editInstituteInfo(instituteInfo: InstituteInfo) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/EditInstituteInfo", {
        params: {
            instituteInfo: instituteInfo
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function createUser(user: UserSignUpInfo) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/CreateUser", {
        params: {
            newUser: user
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function createJobOffer(jobOffer: JobOffer) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/CreateJobOffer", {
        params: {
            jobOffer: jobOffer
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function editAssignment() {
    //da concordare
}

function editActivityPeriod(idIstituto: number, activities: Activities) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/EditActivityPeriod", {
        params: {
            activities: activities
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function sendResetLink(payload: UserResetPassInfo) {
    let errorMsg = ''
    var authToken: string | null;
    if (payload.changeType === "edit") {
        authToken = localStorage.getItem('userToken')
    } else {
        authToken = ""//token creato ad hoc
    }

    return axios.get(headUrl + "/checkEmail", {
        params: {
            email: payload.email,
            username: payload.username
        },
        headers: {
            Authorization: 'Bearer ' + authToken
        }
    }).then((response) => {
        localStorage.setItem('userToken', JSON.stringify(response.data));
        var token: string | null = localStorage.getItem('userToken')
        return axios.post(headUrl + "/registerResetToken", {
            params: {
                token: payload.token,
                username: payload.username
            },
            headers: {
                // Authorization: 'Bearer ' + authToken
                Authorization: 'Bearer ' + token
            }
        }).then(() => {
            var text: string = "<html><head></head><body><p>Segui questo link per resettare la tua password.</p><p>" + siteUrl + "/%23/resetPasswordPage?token=" + payload.token + "</p><p>Se non sei stato tu a richiedere il reset della password ignora pure questa email.</p><p>Il team ValtIS</p></body></html> "
            return axios.post(headUrl + "/Send?&recipient=" +
                payload.email +
                "&sender=noreply@valtis.infosys.it" +
                "&topic=Reset Password ValtIS" +
                "&html=" +
                text
            ).catch(error => {
                bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
                throw error
            })
            //------------------------------------------------
            // return axios.post(headUrl + "/Send", {
            //     params: {
            //         recipient: payload.email,
            //         emailType: 'resetLink',
            //         resetToken: payload.token
            //     },
            //     headers: {
            //         Authorization: 'Bearer ' + token
            //     }
            // }).catch(error => {
            //     bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
            //     throw error
            // })
            //-------------------------------------------------------
        }).catch(error => {
            errorMsg = error.response.data
            // bus.$emit('errorOperation', error.response.data);
            throw error;
        })
    }).catch(error => {
        if(errorMsg === ''){
            errorMsg = 'Username e/o email non validi'
        }
        bus.$emit('errorOperation', errorMsg);
        throw error;
    })
}

function resetPassword(token: string, password: string) {
    return axios.post(headUrl + "/resetPassword", {
        params: {
            token: token,
            password: password
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function submitAuthorizationDoc(autorizzazioneInfo: DocAutorizzazioneInfo, idAllievo: number, idAnnoScolastico: number, idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/AuthorizationDoc", {
        params: {
            autorizzazioneInfo: autorizzazioneInfo,
            idAllievo: idAllievo,
            idAnnoScolastico: idAnnoScolastico,
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function submitResponsabileDatiDoc(firmaUno: string, firmaDue: string, idAzienda: number, idIstituto: number, data: string, nomeAzienda: string, nomeIstituto: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/DocResponsabile", {
        params: {
            firmaUno: firmaUno,
            firmaDue: firmaDue,
            idAzienda: idAzienda,
            idIstituto: idIstituto,
            data: data,
            nomeAzienda: nomeAzienda,
            nomeIstituto: nomeIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error
    })
}

function confirmResponsabileDatiDoc(idDoc: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ConfirmResponsabileDoc", {
        params: {
            idDoc: idDoc
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function refuseResponsabileDatiDoc(idDoc: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RefuseResponsabileDoc", {
        params: {
            idDoc: idDoc
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function updateResponsabileDatiDoc(firmaUno: string, firmaDue: string, idAzienda: number, idIstituto: number, data: string, nomeAzienda: string, nomeIstituto: string, idDoc: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/UpdateResponsabileDoc", {
        params: {
            firmaUno: firmaUno,
            firmaDue: firmaDue,
            idAzienda: idAzienda,
            idIstituto: idIstituto,
            data: data,
            nomeAzienda: nomeAzienda,
            nomeIstituto: nomeIstituto,
            idDoc: idDoc
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function confirmAutorizzazioneStudentiDoc(idDoc: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ConfirmAutorizzazioneStudentiDoc", {
        params: {
            idDoc: idDoc
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function refuseAutorizzazioneStudentiDoc(idDoc: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RefuseAutorizzazioneStudentiDoc", {
        params: {
            idDoc: idDoc
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function updateAutorizzazioneStudentiDoc(docElements: DocAutorizzazioneInfo) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/UpdateAutorizzazioneStudentiDoc", {
        params: {
            docElements: docElements
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function submitRichiestaAlternanza(elements: RichiestaAlternanza) {

    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RichiestaAlternanza", {
        params: {
            elements: elements
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function subscribeToActivities(idAzienda: number, idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RegistrazioneAdAttivita", {
        params: {
            idAzienda: idAzienda,
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function subscribeToAlternanza(idAziendaIstitutoAnno: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RegistrazioneAdAlternanza", {
        params: {
            idAziendaIstitutoAnno: idAziendaIstitutoAnno
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function refuseDoc(docType: string, email: string) {
    var doc: string;
    if(docType === "docDVR"){
        doc = 'Valutazione dei Rischi (DVR)'
    } else if (docType === "autorizzazioneAllievo") {
        doc = 'Patto di Corresponsabilità'
    } else {
        doc = 'Nomina Trattamento Responsabile Dati'
    }

    var text: string = "";
    if(docType === "docDVR"){
        text = "<html><head></head><body><h2>Documento Rifiutato</h2><p>Il documento " + doc + ", da lei inviato all'Istituto, è stato rifiutato.</p><p>Si prega di ricaricarlo</p><p>Il team di ValtIS</p>"
    }
    else{
        text = "<html><head></head><body><h2>Documento Rifiutato</h2><p>Il documento " + doc + ", da lei inviato all'Istituto, è stato rifiutato.</p><p>Si prega di ricompilarlo e procedere al reinvio</p><p>Il team di ValtIS</p>"
    }

    return axios.post(headUrl + "/Send?&recipient=" +
        email +
        "&sender=noreply@valtis.infosys.it" +
        "&topic=Documento ValtIS rifiutato" +
        "&html=" +
        text
    ).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}

function confirmDoc(docType: string, email: string) {
    var doc: string;
    var text: string;
    if (docType === "autorizzazioneAllievo") {
        doc = 'Patto di Corresponsabilità'
        text = "<html><head></head><body><h2>Documento Accettato</h2><p>Il documento " + doc + ", da lei inviato all'Istituto, è stato accettato.</p><p>Il team di ValtIS</p>"
    } else {
        doc = 'Nomina Trattamento Responsabile Dati'
        text = "<html><head></head><body><h2>Documento Accettato</h2><p>Il documento " + doc + ", da lei inviato all'Istituto, è stato accettato.</p><p>Adesso è possible procedere con l'iscrizione alle attività</p><p>Il team di ValtIS</p>"
    }

    return axios.post(headUrl + "/Send?&recipient=" +
        email +
        "&sender=noreply@valtis.infosys.it" +
        "&topic=Documento ValtIS accettato" +
        "&html=" +
        text
    ).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}

function deleteRichiestaAlternanza(idRichiesta: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/CancellazioneRichiestaAlternanza", {
        params: {
            idRichiesta: idRichiesta
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function updateRichiestaAlternanza(richiestaInfo: RichiestaAlternanza) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/UpdateRichiestaAlternanza", {
        params: {
            richiestaInfo: richiestaInfo
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function addUserRole(username: string, newRole: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/AddUserRole", {
        params: {
            username: username,
            newRole: newRole
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function updateUserRole(username: string, newRole: number, oldRole: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ChangeUserRole", {
        params: {
            username: username,
            newRole: newRole,
            oldRole: oldRole
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function deleteUserRole(username: string, role: number, idUtente: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/DeleteUserRole", {
        params: {
            username: username,
            role: role,
            idUtente: idUtente
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function deleteAssegnazioneIndirizzoStudio(idUtente: number, idIndirizzoStudio: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/DeleteAssegnazioneIndirizzoStudio", {
        params: {
            idUtente: idUtente,
            idIndirizzoStudio: idIndirizzoStudio
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function deleteAssegnazioneArticolazione(idUtente: number, idArticolazione: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/DeleteAssegnazioneArticolazione", {
        params: {
            idUtente: idUtente,
            idArticolazione: idArticolazione
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function confirmAssegnazioneArticolazione(idUtente: number, idArticolazione: string, idOldArticolazione: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ConfirmAssegnazioneArticolazione", {
        params: {
            idUtente: idUtente,
            idArticolazione: idArticolazione,
            idOldArticolazione: idOldArticolazione
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function confirmAssegnazioneIndirizzoStudio(idUtente: number, idIndirizzoStudio: number, idOldIndirizzoStudio: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ConfirmAssegnazioneIndirizzoStudio", {
        params: {
            idUtente: idUtente,
            idIndirizzoStudio: idIndirizzoStudio,
            idOldIndirizzoStudio: idOldIndirizzoStudio
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function assignTutorToAllievo(idIstituto: number, idAnnoScolastico: number, idAllievo: number, idTutor: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/AssignTutorToAllievo", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idAllievo: idAllievo,
            idTutor: idTutor
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function changeStudentActivityStatus(idAllievo: number, idIstitutoAnnoScolastico: number, idClasse: number, gestioneAlternanza: boolean) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ChangeStudentActivityStatus", {
        params: {
            idAllievo: idAllievo,
            idIstitutoAnnoScolastico: idIstitutoAnnoScolastico,
            idClasse: idClasse,
            gestioneAlternanza: gestioneAlternanza
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function assignAllievoToAzienda(idIstituto: number, idAnnoScolastico: number, idAllievo: number, idTutor: number, idRichiesta: number, idRichiestaOld: number, attivita: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/AssignAllievoToAzienda", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idAllievo: idAllievo,
            idTutor: idTutor,
            idRichiesta: idRichiesta,
            idRichiestaOld: idRichiestaOld,
            attivita: attivita
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function subscribeToColloqui(idAziendaIstitutoAnno: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RegistrazioneAColloqui", {
        params: {
            idAziendaIstitutoAnno: idAziendaIstitutoAnno
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function registerSchedule(idAllievo: number, idAzienda: number, idIstituto: number, idAnnoScolastico: number, idArticolazione: string, nTurno: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RegistrazioneSchedule", {
        params: {
            idAllievo: idAllievo,
            idAzienda: idAzienda,
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idArticolazione: idArticolazione,
            nTurno: nTurno
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function sendQuestionarioCV(idSchedulazione: number, nomeSelezionatore: string, cognomeSelezionatore: string, esito: number, note: string, posizioneRichiesta: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/UpdateSchedule", {
        params: {
            idSchedulazione: idSchedulazione,
            nomeSelezionatore: nomeSelezionatore,
            cognomeSelezionatore: cognomeSelezionatore,
            esito: esito,
            note: note,
            posizioneRichiesta: posizioneRichiesta
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function sendLinkColloquioCV(nomeAllievo: string, cognomeAllievo: string, emailAllievo: string, turno: string, nomeAzienda: string, emailAzienda: string, linkColloquio: string) {
    var token: string | null = localStorage.getItem('userToken')
    var text: string = "<html><head></head><body><p>Studente " + cognomeAllievo + " " + nomeAllievo + ",</p><p>Sei stato invitato dall'Azienda " + nomeAzienda + " (email: " + emailAzienda + " )" + " a partecipare al colloquio di selezione delle ore " + turno + " sulla piattaforrma ValtIS.</p><p>Segui questo link per partecipare: " + linkColloquio + "</p><p>Se non sei stato tu a richiedere di partecipare al colloqui ignora pure questa email.</p><p>Il team ValtIS</p></body></html> "
    return axios.post(headUrl + "/Send?&recipient=" +
        emailAllievo +
        "&sender=noreply@valtis.infosys.it" +
        "&topic=Link Colloqui CV" +
        "&html=" +
        text)
        .catch(error => {
            bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
            throw error
        })
}

function subscribeToTirEstivi(idAziendaIstitutoAnno: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RegistrazioneATirEstivi", {
        params: {
            idAziendaIstitutoAnno: idAziendaIstitutoAnno
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function submitRichiestaTirEstivo(elements: RichiestaTirEstivi) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RichiestaTirEstivo", {
        params: {
            elements: elements
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function deleteRichiestaTirEstivo(idRichiesta: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/CancellazioneRichiestaTirEstivo", {
        params: {
            idRichiesta: idRichiesta
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function updateRichiestaTirEstivo(richiestaInfo: RichiestaTirEstivi) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/UpdateRichiestaTirEstivo", {
        params: {
            richiestaInfo: richiestaInfo
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function assignAllievoToAziendaTirEstivo(idIstituto: number, idAnnoScolastico: number, idAllievo: number, idTutor: number, idRichiesta: number, idRichiestaOld: number, attivita: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/AssignAllievoToAziendaTirEstivo", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idAllievo: idAllievo,
            idTutor: idTutor,
            idRichiesta: idRichiesta,
            idRichiestaOld: idRichiestaOld,
            attivita: attivita
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function updatePreAssegnamentoTirEstivo(dataInizioPeriodo: string, dataFinePeriodo: string, oraInizioMattino: string, oraFineMattino: string, oraInizioPomeriggio: string, oraFinePomeriggio: string, idTutorAziendale: number, facilitazioni: string, idRichiesta: number, attivita: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/UpdatePreAssegnamentoTirEstivo", {
        params: {
            dataInizioPeriodo: dataInizioPeriodo,
            dataFinePeriodo: dataFinePeriodo,
            oraInizioMattino: oraInizioMattino,
            oraFineMattino: oraFineMattino,
            oraInizioPomeriggio: oraInizioPomeriggio,
            oraFinePomeriggio: oraFinePomeriggio,
            idTutorAziendale: idTutorAziendale,
            facilitazioni: facilitazioni,
            idRichiesta: idRichiesta,
            attivita: attivita
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function updatePreAssegnamentoAlternanza(dataInizioPeriodo: string, dataFinePeriodo: string, oraInizioMattino: string, oraFineMattino: string, oraInizioPomeriggio: string, oraFinePomeriggio: string, idTutorAziendale: number, facilitazioni: string, idRichiesta: number, attivita: string, hasSecondPeriod: boolean, dataInizioSecondoPeriodo: string, dataFineSecondoPeriodo: string, oraInizioMattinoSecondoPeriodo: string, oraFineMattinoSecondoPeriodo: string, oraInizioPomeriggioSecondoPeriodo: string, oraFinePomeriggioSecondoPeriodo: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/UpdatePreAssegnamentoAlternanza", {
        params: {
            dataInizioPeriodo: dataInizioPeriodo,
            dataFinePeriodo: dataFinePeriodo,
            oraInizioMattino: oraInizioMattino,
            oraFineMattino: oraFineMattino,
            oraInizioPomeriggio: oraInizioPomeriggio,
            oraFinePomeriggio: oraFinePomeriggio,
            idTutorAziendale: idTutorAziendale,
            facilitazioni: facilitazioni,
            idRichiesta: idRichiesta,
            attivita: attivita,
            hasSecondPeriod: hasSecondPeriod,
            dataInizioSecondoPeriodo: dataInizioSecondoPeriodo,
            dataFineSecondoPeriodo: dataFineSecondoPeriodo,
            oraInizioMattinoSecondoPeriodo: oraInizioMattinoSecondoPeriodo,
            oraFineMattinoSecondoPeriodo: oraFineMattinoSecondoPeriodo,
            oraInizioPomeriggioSecondoPeriodo: oraInizioPomeriggioSecondoPeriodo,
            oraFinePomeriggioSecondoPeriodo: oraFinePomeriggioSecondoPeriodo
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function assignTutorFormToRichiestaTirEstivo(idIstituto: number, idAnnoScolastico: number, idAllievo: number, idTutor: number, idTutorForm: number, idRichiesta: number, attivita: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/AssignTutorFormToRichiestaTirEstivo", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idAllievo: idAllievo,
            idTutor: idTutor,
            idTutorForm: idTutorForm,
            idRichiesta: idRichiesta,
            attivita: attivita
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function confirmAbbinamento(idRichiesta: number, activityType: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ConfermaAbbinamento", {
        params: {
            idRichiesta: idRichiesta,
            activityType: activityType
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function generaDocumenti(idRichiesta: number, activityType: string, numeroProtocollazione: string, dataProtocollazione: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/GeneraDocumenti", {
        params: {
            idRichiesta: idRichiesta,
            activityType: activityType,
            numeroProtocollazione: numeroProtocollazione,
            dataProtocollazione: dataProtocollazione
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function signConvenzione(idConvenzione: number, firmaAzienda: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/SignConvenzione", {
        params: {
            idConvenzione: idConvenzione,
            firmaAzienda: firmaAzienda
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function signProgettoOrientamento(idProgettoOrientamento: number, firma: string, firmaDue: string, soggetto: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/SignProgettoOrientamento", {
        params: {
            idProgettoOrientamento: idProgettoOrientamento,
            firma: firma,
            firmaDue: firmaDue,
            soggetto: soggetto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function confirmConvenzione(idConvenzione: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ConfirmConvenzione", {
        params: {
            idConvenzione: idConvenzione
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function refuseConvenzione(idConvenzione: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RefuseConvenzione", {
        params: {
            idConvenzione: idConvenzione
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function confirmProgettoOrientamento(idProgettoOrientamento: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ConfirmProgettoOrientamento", {
        params: {
            idProgettoOrientamento: idProgettoOrientamento
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function refuseProgettoOrientamento(idProgettoOrientamento: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RefuseProgettoOrientamento", {
        params: {
            idProgettoOrientamento: idProgettoOrientamento
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

// function refusePercorsoFormativo(idPercorsoFormativo: number) {
//     var token: string | null = localStorage.getItem('userToken')
//     return axios.post(headUrl + "/RefusePercorsoFormativo", {
//         params: {
//             idPercorsoFormativo: idPercorsoFormativo
//         },
//         headers: {
//             Authorization: 'Bearer ' + token
//         }
//     }).then(response => {
//         return response.data
//     }).catch(error => {
//         bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
//         throw error;
//     })
// }

// function confirmPercorsoFormativo(idPercorsoFormativo: number) {
//     var token: string | null = localStorage.getItem('userToken')
//     return axios.post(headUrl + "/ConfirmPercorsoFormativo", {
//         params: {
//             idPercorsoFormativo: idPercorsoFormativo
//         },
//         headers: {
//             Authorization: 'Bearer ' + token
//         }
//     }).then(response => {
//         return response.data
//     }).catch(error => {
//         bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
//         throw error;
//     })
// }

function subscribeToTirFormativi(idAziendaIstitutoAnno: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RegistrazioneATirFormativi", {
        params: {
            idAziendaIstitutoAnno: idAziendaIstitutoAnno
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function submitRichiestaTirFormativo(elements: RichiestaTirFormativi) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RichiestaTirFormativo", {
        params: {
            elements: elements
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function assignAllievoToAziendaTirFormativo(idIstituto: number, idAnnoScolastico: number, idAllievo: number, idTutor: number, idRichiesta: number, idRichiestaOld: number, attivita: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/AssignAllievoToAziendaTirFormativo", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idAllievo: idAllievo,
            idTutor: idTutor,
            idRichiesta: idRichiesta,
            idRichiestaOld: idRichiestaOld,
            attivita: attivita
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function assignTutorFormToRichiestaTirFormativo(idIstituto: number, idAnnoScolastico: number, idAllievo: number, idTutor: number, idTutorForm: number, idRichiesta: number, attivita: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/AssignTutorFormToRichiestaTirFormativo", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idAllievo: idAllievo,
            idTutor: idTutor,
            idTutorForm: idTutorForm,
            idRichiesta: idRichiesta,
            attivita: attivita
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function saveAssegnazioneAllievoAzienda(idRichiesta: number, attivita: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/SaveAssegnazioneAllievoAzienda", {
        params: {
            idRichiesta: idRichiesta,
            attivita: attivita
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function refusePreAbbinamento(idRichiesta: number, attivita: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RefusePreAbbinamento", {
        params: {
            idRichiesta: idRichiesta,
            attivita: attivita
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function createReportVisita(reportVisita: ReportVisiteInfo) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/CreateReportVisita", {
        params: {
            reportVisita: reportVisita
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function sendConfirmReport(emailAzienda: string, emailTutor: string, tutorAziendale: string, tirocinante: string, dataVisita: string, tutorFormativo: string, activityType: string) {
    var text: string;
    var tipoTirocinio: string = ""
    var email: string = ""
    var data: any = new Date(dataVisita)
    data = data.getDate() + "/" + (data.getMonth() + 1) + "/" + data.getFullYear()
    if (activityType === 'tirocinioEstivo') {
        tipoTirocinio = "Tirocini Estivi"
    } else if (activityType === 'tirocinioFormativo') {
        tipoTirocinio = "Tirocini Formativi"
    } else if (activityType === 'alternanza') {
        tipoTirocinio = "FSL Estiva"
    }
    if (emailTutor === null || emailTutor === undefined) {
        email = emailAzienda
        text = "<html><head></head><body><h2>Conferma Visita Tutor Formativo</h2><p>E' stato creato un report visita per l'allievo/a " + tirocinante + " da parte del tutor formativo " + tutorFormativo + " per la data " + data + ".</p><p>E' necessario che il tutor aziendale " + tutorAziendale + " confermi oppure neghi l'avvenuta visita accedendo alla propria area del portale (Gestione Tirocini -> " + tipoTirocinio + " -> Report Visita).</p><p>Il team ValtIS</p></body></html>"
    } else {
        email = emailTutor
        text = "<html><head></head><body><h2>Conferma Visita Tutor Formativo</h2><p>E' stato creato un report visita per l'allievo/a " + tirocinante + " da parte del tutor formativo " + tutorFormativo + " per la data " + data + "</p><p>E' necessario confermare oppure negare l'avvenuta visita accedendo alla propria area del portale con l'account del <b>Tutor Aziendale</b> (Gestione Tirocini -> " + tipoTirocinio + " -> Report Visita).</p><p>Il team ValtIS</p></body></html>"
    }
    // var text: string = "<html><head></head><body><h2>Conferma Visita Tutor Formativo</h2><p></p>"

    return axios.post(headUrl + "/Send?&recipient=" +
        email +
        "&sender=noreply@valtis.infosys.it" +
        "&topic=Conferma Visita Tutor Formativo" +
        "&html=" +
        text
    ).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}

function refuseReportVisita(idReport: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RefuseReportVisita", {
        params: {
            idReport: idReport
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function signReportVisita(idReport: number, firmaTutorAziendale: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/SignReportVisita", {
        params: {
            idReport: idReport,
            firmaTutorAziendale: firmaTutorAziendale
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function signConsenso(idConsenso: number, firma: string, soggetto: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/SignConsenso", {
        params: {
            idConsenso: idConsenso,
            firma: firma,
            soggetto: soggetto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function confirmConsenso(idConsenso: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ConfirmConsenso", {
        params: {
            idConsenso: idConsenso
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function refuseConsenso(idConsenso: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RefuseConsenso", {
        params: {
            idConsenso: idConsenso
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function sendEmailAssegnazioneAllievoAzienda(denominazioneAzienda: string, tirocinante: string, emailAzienda: string, emailTirocinante: string, activityType: string) {
    var textAzienda: string;
    var textTirocinante: string;
    var tipoTirocinio: string = ""
    var objEmail: string = ""
    var email: string = ""

    if (activityType === 'tirocinioEstivo') {
        tipoTirocinio = "Tirocini Estivi"
        objEmail = "Tirocinio Estivo"
    } else if (activityType === 'tirocinioFormativo') {
        tipoTirocinio = "Tirocini Formativi"
        objEmail = "Tirocinio Formativo e di Orientamento"
    } else if (activityType === 'alternanza') {
        tipoTirocinio = "FSL Estiva"
        objEmail = "FSL Estiva"
    }

    // var text: string = "<html><head></head><body><h2>Conferma Visita Tutor Formativo</h2><p></p>"

    textAzienda = "<html><head></head><body><h2>Abbinamento " + objEmail + "</h2><p>A seguito della disponibilità indicata sul portale ValtIS si è stati assegnati dall'Istituto all'Allievo/a " + tirocinante + ".</p><p>Accettare o rifiutare l'abbinamento accedendo al portale e seguendo il percorso 'Gestione Tirocini' -> " + tipoTirocinio + " -> 'Conferma Abbinamento'.</p><p>In caso di accettazione sarà necessario completare la procedura compilando le ultime informazoni sull'attività.</p><p>Si consiglia di mettersi in contatto con l'Allievo/a, all'email " + emailTirocinante + ", per concordare periodo, orario ed eventuali facilitazioni per il tirocinio.</p><p>Il team ValtIS</p></body></html>"
    textTirocinante = "<html><head></head><body><h2>Abbinamento " + objEmail + "</h2><p>Si è stati abbinati dall'Istituto per l'attività di 'Tirocinio Formativo e di Orientamento' all'azienda " + denominazioneAzienda + ".</p><p>Mettersi in contatto con l'azienda, all'email " + emailAzienda + ", per concordare periodo, orario ed eventuali facilitazioni per il tirocinio.</p><p>Il team ValtIS</p></body></html>"

    return axios.post(headUrl + "/Send?&recipient=" +
        emailAzienda +
        "&sender=noreply@valtis.infosys.it" +
        "&topic=Abbinamento " + objEmail +
        "&html=" +
        textAzienda
    ).then(() => {
        return axios.post(headUrl + "/Send?&recipient=" +
            emailTirocinante +
            "&sender=noreply@valtis.infosys.it" +
            "&topic=Abbinamento " + objEmail +
            "&html=" +
            textTirocinante
        )
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}

function sendEmailAbbinamentoCompletato(emailTutorArticolazione: string, denominazioneAzienda: string, tirocinante: string, activityType: string, statusAccettazione: string) {
    var text: string
    var tipoTirocinio: string = ""

    if (activityType === 'tirocinioEstivo') {
        tipoTirocinio = "Tirocini Estivi"
    } else if (activityType === 'tirocinioFormativo') {
        tipoTirocinio = "Tirocini Formativi"
    } else if (activityType === 'alternanza') {
        tipoTirocinio = "FSL Estiva"
    } else if (activityType === 'tirocinioReIns') {
        tipoTirocinio = "Tirocini Re/Inserimento"
    }
    if (statusAccettazione === 'accettato') {
        // var text: string = "<html><head></head><body><h2>Conferma Visita Tutor Formativo</h2><p></p>"
        text = "<html><head></head><body><h2>Conferma Abbinamento " + tipoTirocinio + "</h2><p>L'azienda " + denominazioneAzienda + " ha confermato l'abbinamento con l'Allievo/a " + tirocinante + ".</p><p>Confermare definitivamente l'abbinamento seguendo il percorso 'Gest. " + tipoTirocinio + " -> Abbinamenti -> Conferma'.</p><p>A seguito della conferma verranno generati automaticamente i documenti per l'attività.</p></body></html>"

        return axios.post(headUrl + "/Send?&recipient=" +
            emailTutorArticolazione +
            "&sender=noreply@valtis.infosys.it" +
            "&topic=Conferma Abbinamento" +
            "&html=" +
            text
        ).catch(error => {
            bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
            throw error
        })
    } else {
        text = "<html><head></head><body><h2>Abbinamento " + tipoTirocinio + " Rifiutato</h2><p>L'azienda " + denominazioneAzienda + " ha rifiutato l'abbinamento con l'Allievo/a " + tirocinante + ".</p></body></html>"

        return axios.post(headUrl + "/Send?&recipient=" +
            emailTutorArticolazione +
            "&sender=noreply@valtis.infosys.it" +
            "&topic=Rifiuto Abbinamento" +
            "&html=" +
            text
        ).catch(error => {
            bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
            throw error
        })
    }
}

function sendEmailConfermaAllievoAlternanza(emailAllievo: string, denominazioneAzienda: string) {
    var text: string

    text = "<html><head></head><body><h2>Conferma Abbinamento FSL Estiva</h2><p>L'azienda " + denominazioneAzienda + " ha confermato l'abbinamento.</p><p>Confermare definitivamente gli orari nella tua pagina Moduli.</p></body></html>"

    return axios.post(headUrl + "/Send?&recipient=" +
        emailAllievo +
        "&sender=noreply@valtis.infosys.it" +
        "&topic=Conferma Abbinamento" +
        "&html=" +
        text
    ).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}

function sendEmailDocGenerati(emailAzienda: string, emailTirocinante: string, denominazioneAzienda: string, tirocinante: string, activityType: string) {
    var textAzienda: string
    var textTirocinante: string;
    var tipoTirocinio: string = ""
    var objEmail: string = ""

    if (activityType === 'tirocinioEstivo') {
        tipoTirocinio = "Tirocinio Estivo"
        objEmail = "Tirocinio Estivo"
    } else if (activityType === 'tirocinioFormativo') {
        tipoTirocinio = "Tirocinio Formativo"
        objEmail = "Tirocinio Formativo e di Orientamento"
    } else if (activityType === 'alternanza') {
        tipoTirocinio = "FSL Estiva"
        objEmail = "FSL Estiva"
    } else if (activityType === 'tirocinioReIns') {
        tipoTirocinio = "Tirocini Re/Inserimento"
        objEmail = "Tirocini Re/Inserimento"
    }


    textAzienda = "<html><head></head><body><h2>Documenti " + tipoTirocinio + " Generati</h2><p>I Documenti per il tirocinio dell'allievo/a " + tirocinante + " sono stati generati.</p><p>Accedere al portale e firmare i documenti seguendo il percorso 'Gestione Tirocini -> " + tipoTirocinio + " -> Documenti'</p></body></html>"
    textTirocinante = "<html><head></head><body><h2>Documenti " + tipoTirocinio + " Generati</h2><p>I Documenti per il tirocinio con l'Azienda " + denominazioneAzienda + " sono stati generati.</p><p>Accedere al portale e firmare i documenti seguendo il percorso 'Moduli -> Documenti " + tipoTirocinio + "'</p></body></html>"

    return axios.post(headUrl + "/Send?&recipient=" +
        emailAzienda +
        "&sender=noreply@valtis.infosys.it" +
        "&topic=Documenti " + objEmail +
        "&html=" +
        textAzienda
    ).then(() => {
        return axios.post(headUrl + "/Send?&recipient=" +
            emailTirocinante +
            "&sender=noreply@valtis.infosys.it" +
            "&topic=Documenti " + objEmail +
            "&html=" +
            textTirocinante
        )
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}

function updatePreAssegnamentoTirFormativo(dataInizioPeriodo: string, dataFinePeriodo: string, oraInizioMattino: string, oraFineMattino: string, oraInizioPomeriggio: string, oraFinePomeriggio: string, idTutorAziendale: number, facilitazioni: string, idRichiesta: number, attivita: string, responsabilitaCivile: string, assicurazioneAzienda: string, indennitaMensile: string, dataInizioSospensioneUno: string | null, dataFineSospensioneUno: string | null, motivazioneSospensioneUno: string, dataInizioSospensioneDue: string | null, dataFineSospensioneDue: string | null, motivazioneSospensioneDue: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/UpdatePreAssegnamentoTirFormativo", {
        params: {
            dataInizioPeriodo: dataInizioPeriodo,
            dataFinePeriodo: dataFinePeriodo,
            oraInizioMattino: oraInizioMattino,
            oraFineMattino: oraFineMattino,
            oraInizioPomeriggio: oraInizioPomeriggio,
            oraFinePomeriggio: oraFinePomeriggio,
            idTutorAziendale: idTutorAziendale,
            facilitazioni: facilitazioni,
            idRichiesta: idRichiesta,
            attivita: attivita,
            responsabilitaCivile: responsabilitaCivile,
            assicurazioneAzienda: assicurazioneAzienda,
            indennitaMensile: indennitaMensile,
            dataInizioSospensioneUno: dataInizioSospensioneUno,
            dataFineSospensioneUno: dataFineSospensioneUno,
            motivazioneSospensioneUno: motivazioneSospensioneUno,
            dataInizioSospensioneDue: dataInizioSospensioneDue,
            dataFineSospensioneDue: dataFineSospensioneDue,
            motivazioneSospensioneDue: motivazioneSospensioneDue
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function createAttestatoFinale(infoAttestatoFinale: DocAttestatoFinale) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/CreateAttestatoFinale", {
        params: {
            infoAttestatoFinale: infoAttestatoFinale
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function createQuestionario(idRichiesta: number, activityType: string, tipoQuestionario: string, note: string) {
    var token: string | null = localStorage.getItem('userToken')
    var idActivityType: number = 0;
    var idTipoQuestionario: number = 0;
    if (activityType === 'tirocinioEstivo') {
        idActivityType = 1
    } else if (activityType === 'alternanza') {
        idActivityType = 2
    } else if (activityType === 'workshop') {
        idActivityType = 5
    }

    if (tipoQuestionario === 'questionarioTirocinante') {
        idTipoQuestionario = 1;
    } else if (tipoQuestionario === 'questionarioAzienda') {
        idTipoQuestionario = 2;
    } else if (tipoQuestionario === 'questionarioWorkshopAzienda') {
        idTipoQuestionario = 4
    } else if (tipoQuestionario === 'questionarioWorkshopAllievo') {
        idTipoQuestionario = 5
    }
    return axios.post(headUrl + "/CreateQuestionario", {
        params: {
            idRichiesta: idRichiesta,
            idActivityType: idActivityType,
            idTipoQuestionario: idTipoQuestionario,
            note: note
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function saveResponse(idQuestionario: number, idDomanda: number, risposta: number, notaRisposta: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/SaveRisposta", {
        params: {
            idQuestionario: idQuestionario,
            idDomanda: idDomanda,
            risposta: risposta,
            notaRisposta: notaRisposta
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function changeStatusPeriodoIscrizioneAttivita(idAttivita: number, statoIscrizione: boolean) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ChangeStatusPeriodoIscrizioneAttivita", {
        params: {
            idAttivita: idAttivita,
            statoIscrizione: statoIscrizione
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function editAttivitaIstituto(attivita: AttivitaIstituto) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/EditAttivitaIstituto", {
        params: {
            attivita: attivita
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function createAttivitaIstituto(attivita: AttivitaIstituto) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/CreateAttivitaIstituto", {
        params: {
            attivita: attivita
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function assignTutorFormToRichiestaAlternanza(idIstituto: number, idAnnoScolastico: number, idAllievo: number, idTutor: number, idTutorForm: number, idRichiesta: number, attivita: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/AssignTutorFormToRichiestaAlternanza", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idAllievo: idAllievo,
            idTutor: idTutor,
            idTutorForm: idTutorForm,
            idRichiesta: idRichiesta,
            attivita: attivita
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function signPercorsoFormativo(idPercorsoFormativo: number, firma: string, firmaDue: string, firmaTutore: string, soggetto: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/SignPercorsoFormativo", {
        params: {
            idPercorsoFormativo: idPercorsoFormativo,
            firma: firma,
            firmaDue: firmaDue,
            firmaTutore: firmaTutore,
            soggetto: soggetto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function refuseAssignment(idRichiesta: number, activityType: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RefuseAssignment", {
        params: {
            idRichiesta: idRichiesta,
            activityType: activityType
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function updatePreAssegnamentoTirReIns(dataInizioPeriodo: string, dataFinePeriodo: string, oraInizioMattino: string, oraFineMattino: string, oraInizioPomeriggio: string, oraFinePomeriggio: string, idTutorAziendale: number, facilitazioni: string, idRichiesta: number, attivita: string, responsabilitaCivile: string, assicurazioneAzienda: string, indennitaMensile: string, dataInizioSospensioneUno: string | null, dataFineSospensioneUno: string | null, motivazioneSospensioneUno: string, dataInizioSospensioneDue: string | null, dataFineSospensioneDue: string | null, motivazioneSospensioneDue: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/UpdatePreAssegnamentoTirReIns", {
        params: {
            dataInizioPeriodo: dataInizioPeriodo,
            dataFinePeriodo: dataFinePeriodo,
            oraInizioMattino: oraInizioMattino,
            oraFineMattino: oraFineMattino,
            oraInizioPomeriggio: oraInizioPomeriggio,
            oraFinePomeriggio: oraFinePomeriggio,
            idTutorAziendale: idTutorAziendale,
            facilitazioni: facilitazioni,
            idRichiesta: idRichiesta,
            attivita: attivita,
            responsabilitaCivile: responsabilitaCivile,
            assicurazioneAzienda: assicurazioneAzienda,
            indennitaMensile: indennitaMensile,
            dataInizioSospensioneUno: dataInizioSospensioneUno,
            dataFineSospensioneUno: dataFineSospensioneUno,
            motivazioneSospensioneUno: motivazioneSospensioneUno,
            dataInizioSospensioneDue: dataInizioSospensioneDue,
            dataFineSospensioneDue: dataFineSospensioneDue,
            motivazioneSospensioneDue: motivazioneSospensioneDue
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function deletePreferenzaWorkshop(idInformazione: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/DeletePreferenzaWorkshop", {
        params: {
            idInformazione: idInformazione
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function updatePreferenzaWorkshop(idInformazione: number, articolazione: string, scelta: string, nomeReferente: string, cognomeReferente: string, emailReferente: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/UpdatePreferenzaWorkshop", {
        params: {
            idInformazione: idInformazione,
            articolazione: articolazione,
            scelta: scelta,
            nomeReferente: nomeReferente,
            cognomeReferente: cognomeReferente,
            emailReferente: emailReferente
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function createPreferenzaWorkshop(idIscrizioneAttivita: number, articolazione: string, scelta: string, nomeReferente: string, cognomeReferente: string, emailReferente: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/CreatePreferenzaWorkshop", {
        params: {
            idIscrizioneAttivita: idIscrizioneAttivita,
            articolazione: articolazione,
            scelta: scelta,
            nomeReferente: nomeReferente,
            cognomeReferente: cognomeReferente,
            emailReferente: emailReferente
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function createPropostaLavoro(propostaLavoro: PropostaLavoroInfo) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/CreatePropostaLavoro", {
        params: {
            propostaLavoro: propostaLavoro
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function editPropostaLavoro(propostaLavoro: PropostaLavoroInfo) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/EditPropostaLavoro", {
        params: {
            propostaLavoro: propostaLavoro
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function creaCandidaturaLavoro(idProposta: number, idAllievo: number, dataCandidatura: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/CreaCandidaturaLavoro", {
        params: {
            idProposta: idProposta,
            idAllievo: idAllievo,
            dataCandidatura: dataCandidatura
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function sendCandidaturaLavoro(emailContatto: string, allievo: string, istituto: string, nomeProposta: string) {
    var text: string = "<html><head></head><body><h2>Candidatura Offerta Lavorativa</h2><p>Lo Studente " + allievo + ", dell'Istituto " + istituto + ", si è candidato per l'offerta '" + nomeProposta + "'.</p><p>Per visionare la candidatura accedere alla propria pagina aziendale.</p><p>Il team di ValtIS.</p>"
    return axios.post(headUrl + "/Send?&recipient=" +
        emailContatto +
        "&sender=noreply@valtis.infosys.it" +
        "&topic=Candidatura Offerta Lavorativa" +
        "&html=" +
        text
    ).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}

function changeStatusCandidatura(idCandidatura: number, colloquioAvvenuto: boolean) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ChangeStatusCandidatura", {
        params: {
            idCandidatura: idCandidatura,
            colloquioAvvenuto: colloquioAvvenuto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function changeStatusPresenzaWorkshop(idInformazioneWorkshop: number, presenzaWorkshop: boolean) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ChangeStatusPreferenzaWorkshop", {
        params: {
            idInformazioneWorkshop: idInformazioneWorkshop,
            presenzaWorkshop: presenzaWorkshop
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function addGiornoWorkshop(idIstituto: number, idAnnoScolastico: number, giorno: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/AddGiornoWorkshop", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            giorno: giorno
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function deleteGiornoWorkshop(idGiorno: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/DeleteGiornoWorkshop", {
        params: {
            idGiorno: idGiorno
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function editGiornoWorkshop(idGiorno: number, giorno: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/EditGiornoWorkshop", {
        params: {
            idGiorno: idGiorno,
            giorno: giorno
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function addTurnoWorkshop(idIstituto: number, idAnnoScolastico: number, turno: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/AddTurnoWorkshop", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            turno: turno
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function editTurnoWorkshop(idTurno: number, turno: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/EditTurnoWorkshop", {
        params: {
            idTurno: idTurno,
            turno: turno
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function deleteTurnoWorkshop(idTurno: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/DeleteTurnoWorkshop", {
        params: {
            idTurno: idTurno
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function saveScheduleWorkshop(idInformazioneWorkshop: number, idTurno: number, idGiorno: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/SaveScheduleWorkshop", {
        params: {
            idInformazioneWorkshop: idInformazioneWorkshop,
            idTurno: idTurno,
            idGiorno: idGiorno
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function deleteScheduleWorkshop(idInformazioneWorkshop: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/DeleteScheduleWorkshop", {
        params: {
            idInformazioneWorkshop: idInformazioneWorkshop
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function uploadCV(formData: FormData) {
    var token: string | null = localStorage.getItem('userToken')
    // return axios.post(headUrl + "/UploadCV", {
    // params: {
    //     formData: formData
    // },
    // headers: {
    //     Authorization: 'Bearer ' + token
    // }
    return axios.post(headUrl + "/UploadCV", formData
    ).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function deleteCandidatura(idCandidatura: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/DeleteCandidatura", {
        params: {
            idCandidatura: idCandidatura
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function deleteProposta(idProposta: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/DeletePropostaLavoro", {
        params: {
            idProposta: idProposta
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function createAllievo(allievo: any) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/CreateAllievo", {
        params: {
            allievo: allievo
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function concludiAttivita(idRichiesta: number, activityType: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ConcludiAttivita", {
        params: {
            idRichiesta: idRichiesta,
            activityType: activityType
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function createContattoAzienda(nuovoContatto: ContattoAziendaInfo) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/CreaContattoAzienda", {
        params: {
            nuovoContatto: nuovoContatto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function editContattoAzienda(nuovoContatto: ContattoAziendaInfo) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/EditContattoAzienda", {
        params: {
            nuovoContatto: nuovoContatto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function deleteContattoAzienda(idContatto: number, idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/DeleteContattoAzienda", {
        params: {
            idContatto: idContatto,
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function createNotaAzienda(nuovaNota: NotaAzienda) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/NotaAzienda", {
        params: {
            nuovaNota: nuovaNota
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function editNotaAzienda(nuovaNota: NotaAzienda) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.put(headUrl + "/NotaAzienda", {
        params: {
            nuovaNota: nuovaNota
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function deleteNotaAzienda(idNota: number, idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/DeleteNotaAzienda", {
        params: {
            idNota: idNota,
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function deletePreferenzaColloquio(idInformazione: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/DeletePreferenzaColloquio", {
        params: {
            idInformazione: idInformazione
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function createPreferenzaColloquio(idIscrizioneAttivita: number, articolazione: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/CreatePreferenzaColloquio", {
        params: {
            idIscrizioneAttivita: idIscrizioneAttivita,
            articolazione: articolazione
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function saveAssegnazioneAreaAzienda(idInformazioneCV: number, idArea: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/SaveAssegnazioneAreaAzienda", {
        params: {
            idInformazioneCV: idInformazioneCV,
            idArea: idArea
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function saveAssegnazioneAreaAllievo(idIscrizione: number, idArea: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/SaveAssegnazioneAreaAllievo", {
        params: {
            idIscrizione: idIscrizione,
            idArea: idArea
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function deleteAssegnazioneAreaAllievo(idAssegnazione: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/DeleteAssegnazioneAreaAllievo", {
        params: {
            idAssegnazione: idAssegnazione
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function deleteIscrizioneAttivitaAllievo(idIscrizioneAttivita: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/DeleteIscrizioneAttivitaAllievo", {   
        params: {
            idIscrizioneAttivita: idIscrizioneAttivita
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}


function deleteAssegnazioneAreaAzienda(idAssegnazione: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/DeleteAssegnazioneAreaAzienda", {
        params: {
            idAssegnazione: idAssegnazione
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function deleteAssociazioneAllievoAzienda(idRichiesta: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/DeleteAssociazioneAllievoAzienda", {
        params: {
            idRichiesta: idRichiesta
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function verificaUtente(piva: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/VerificaUtente", {
        params: {
            piva: piva
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function changeStatusPresenzaColloquio(idColloquio: number, colloquioAvvenuto: boolean, soggetto: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ChangeStatusPresenzaColloquio", {
        params: {
            idColloquio: idColloquio,
            colloquioAvvenuto: colloquioAvvenuto,
            soggetto: soggetto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function changeStatusPubblicazioneAttivita(idAttivita: number, statoPubblicazione: boolean) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ChangeStatusPubblicazioneAttivita", {
        params: {
            idAttivita: idAttivita,
            statoPubblicazione: statoPubblicazione
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function deleteColloquioCV(idColloquio: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/DeleteColloquioCV", {
        params: {
            idColloquio: idColloquio
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function changeTurnoColloquioCV(idTurno: number, idColloquio: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ChangeTurnoColloquioCV", {
        params: {
            idTurno: idTurno,
            idColloquio: idColloquio
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function createGiornoFoglioFirme(idRichiesta: number, activityType: string, dataFirma: string, orarioInizioMattina: string, orarioFineMattina: string, orarioInizioPomeriggio: string, orarioFinePomeriggio: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/CreateGiornoFoglioFirme", {
        params: {
            idRichiesta: idRichiesta,
            activityType: activityType,
            dataFirma: dataFirma,
            orarioInizioMattina: orarioInizioMattina,
            orarioFineMattina: orarioFineMattina,
            orarioInizioPomeriggio: orarioInizioPomeriggio,
            orarioFinePomeriggio: orarioFinePomeriggio
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function deleteGiornoFoglioFirme(idFirma:number){
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/DeleteGiornoFoglioFirme", {
        params: {
            idFirma:idFirma
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function changeCorsoSicurezzaStatus(idUtente: number, statusCorso: boolean){
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ChangeCorsoSicurezzaStatus", {
        params: {
            idUtente:idUtente,
            statusCorso:statusCorso
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function acceptRichiestaAlternaza(idRichiesta: number){
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/AcceptRichiestaAlternanza", {
        params: {
            idRichiesta:idRichiesta
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })   
}

function refuseRichiestaAlternaza(idRichiesta: number, note: string){
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RefuseRichiestaAlternanza", {
        params: {
            idRichiesta:idRichiesta,
            note:note
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })   
}

function createIspezione(ispezione: any) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/CreateIspezione", {
        params: {
            ispezione: ispezione
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function signIspezione(idIspezione: number, firmaAzienda: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/SignIspezione", {
        params: {
            idIspezione: idIspezione,
            firmaAzienda: firmaAzienda
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function refuseIspezione(idIspezione: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RefuseIspezione", {
        params: {
            idIspezione: idIspezione
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function uploadDocumento(idTipoDocumento: number, idTipoAttivita: number, tipoAttivita: String, idRichiesta: number, base64: any) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/UploadDocumento", {
        params: {
            idTipoDocumento: idTipoDocumento,
            idTipoAttivita: idTipoAttivita,
            tipoAttivita: tipoAttivita,
            idRichiesta: idRichiesta,
            base64: base64
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function confermaConvenzioneAlternanza(idConvenzione:number){
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ConfermaConvenzione", {
        params: {
            idConvenzione: idConvenzione
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function refuseConvenzioneAlternanza(idConvenzione:number){
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RifiutaConvenzione", {
        params: {
            idConvenzione: idConvenzione
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}

function confermaPercorsoFormativo(idPercorsoFormativo:number){
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ConfermaPercorsoFormativo", {
        params: {
            idPercorsoFormativo: idPercorsoFormativo
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function rifiutaPercorsoFormativo(idPercorsoFormativo:number){
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RifiutaPercorsoFormativo", {
        params: {
            idPercorsoFormativo: idPercorsoFormativo
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}

function confirmPercorsoFormativo(idPercorsoFormativo:number){
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ConfirmPercorsoFormativo", {
        params: {
            idPercorsoFormativo: idPercorsoFormativo
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server');
        throw error;
    })
}

function refusePercorsoFormativo(idPercorsoFormativo:number){
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RefusePercorsoFormativo", {
        params: {
            idPercorsoFormativo: idPercorsoFormativo
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}

function sendEmailFirmaDocAlternanza(emailAzienda: string, emailTirocinante: string, denominazioneAzienda: string, tirocinante: string, tipoSoggetto: string) {
    var textEmail: string = ""
    var tipoTirocinio: string = "FSL Estiva"
    var objEmail: string = "FSL Estiva"
    var emailDestinatario: string = ""

    if(tipoSoggetto == "azienda"){
        textEmail = "<html><head></head><body><h2>Documenti " + tipoTirocinio + " Generati</h2><p>I Documenti per il tirocinio dell'allievo/a " + tirocinante + " sono stati generati.</p><p>Accedere al portale e firmare i documenti seguendo il percorso 'Gestione Tirocini -> " + tipoTirocinio + " -> Documenti'</p><p>I documenti andranno firmati digitalmente in formato PAdES e ricaricati sulla piattaforma.</p></body></html>"
        emailDestinatario = emailAzienda
    }

    if(tipoSoggetto == "allievo"){
        textEmail = "<html><head></head><body><h2>Documenti " + tipoTirocinio + " Generati</h2><p>I Documenti per il tirocinio con l'Azienda " + denominazioneAzienda + " sono stati generati.</p><p>Accedere al portale e firmare i documenti seguendo il percorso 'Moduli -> Documenti " + tipoTirocinio + "'</p></body></html>"
        emailDestinatario = emailTirocinante
    }

    return axios.post(headUrl + "/Send?&recipient=" +
        emailDestinatario +
        "&sender=noreply@valtis.infosys.it" +
        "&topic=Documenti " + objEmail +
        "&html=" +
        textEmail
    ).then(() => {
        
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}

function editTirFormativo(idTirocinio: number, dataInizio: string, dataFine: string, idStatoAccettazione: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/EditTirFormativo", {
        params: {
            idRichiestaTirocinioFormativo: idTirocinio,
            dataInizio: dataInizio,
            dataFine: dataFine,
            idStatoAccettazione: idStatoAccettazione
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}

function deleteAbbinamentoAlternanza(idInfoAlternanza: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/deleteAbbinamentoAlternanza", {
        params: {
            idInfoAlternanza: idInfoAlternanza
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}

function uploadDocDVR(base64: any, idRichiesta: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/UploadDocDVR", {
        params: {
            base64: base64,
            idRichiesta: idRichiesta
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}

function confirmDocDVR(idDocumento: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ConfirmDocDVR", {
        params: {
            idDocumento: idDocumento
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}

function refuseDocDVR(idDocumento: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RefuseDocDVR", {
        params: {
            idDocumento: idDocumento
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}

function confirmOrariAllievo(idInformazioneAlternanza: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/ConfirmOrariAllievo", {
        params: {
            idInformazioneAlternanza: idInformazioneAlternanza
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}

function refuseOrariAllievo(idInformazioneAlternanza: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RefuseOrariAllievo", {
        params: {
            idInformazioneAlternanza: idInformazioneAlternanza
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}

function rateAlternanza(idInformazioneAlternanza: number, rating: number, notaRating: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/RateAlternanza", {
        params: {
            idInformazioneAlternanza: idInformazioneAlternanza,
            rating: rating,
            notaRating: notaRating
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {   
        return response.data
    }).catch(error => { 
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}

function createApprendistato(apprendistato: any) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/Apprendistati", {
        params: {
            apprendistato: apprendistato
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {   
        return response.data
    }).catch(error => { 
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}

function updateApprendistato(apprendistato: any) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.put(headUrl + "/Apprendistati", {
        params: {
            apprendistato: apprendistato
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {   
        return response.data
    }).catch(error => { 
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}

function deleteApprendistato(idApprendistato: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.delete(headUrl + "/Apprendistati", {
        params: {
            idApprendistato: idApprendistato
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}

function updateStatoPercorsoFormativo(idPercorsoFormativo:number, idStatoFirmaAzienda?:number, idStatoFirmaTirocinante?:number, idStatoFirmaTutorArticolazione?:number){
    var token: string | null = localStorage.getItem('userToken')    
    return axios.post(headUrl + "/UpdateStatoPercorsoFormativo", {
        params: {
            idPercorsoFormativo: idPercorsoFormativo,
            idStatoFirmaAzienda: idStatoFirmaAzienda,
            idStatoFirmaTirocinante: idStatoFirmaTirocinante,
            idStatoFirmaTutorArticolazione: idStatoFirmaTutorArticolazione
        },
        headers: {
            Authorization: 'Bearer ' + token    
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', (error.response && error.response.data) || error.message || 'Errore del server')
        throw error
    })
}